import React from "react"
import makeStyles from "@material-ui/core/styles/makeStyles"
import { createStyles } from "@material-ui/core"
import classNames from "classnames";

const useStyles = makeStyles((theme) =>
  createStyles({
    pageHeaderSection: {
      position: 'relative',
    },
    pageHeaderBackgroundImage: {
      [theme.breakpoints.up("md")]: {
        "background-image": props => `url(${props.backgroundImage})`,
        backgroundPosition: "center",
        backgroundSize: 'cover',
        width: '100vw',
        height: props => `${props.backgroundImageHeight}vh`,
        maxWidth: '100%',
      },
    },
    pageHeaderTextPos: {
      color: '#fff',

      [theme.breakpoints.down("sm")]: {
        "background-image": props => `url(${props.backgroundImage})`,
        backgroundSize: 'cover',
        padding: theme.spacing(14, 2, 8, 2),
      },
      [theme.breakpoints.up("md")]: {
        position: "absolute",
        left: "calc(50% - 620px)",
        top: props => props.backgroundTextTopPosition,
      },
    },
  })
)

const PageHeader = ({ backgroundImage, backgroundImageHeight = 40, backgroundTextTopPosition = 150, children, textClassName }) => {
  const classes = useStyles({ backgroundImage, backgroundImageHeight, backgroundTextTopPosition })
  return (
    <section className={classes.pageHeaderSection}>
      <div className={classes.pageHeaderBackgroundImage}/>
      <div className={classNames(classes.pageHeaderTextPos, textClassName)}>
        {children}
      </div>
    </section>
  )
}

PageHeader.propTypes = {}

PageHeader.defaultProps = {}

export default PageHeader
